import { Icon } from '@chakra-ui/react';

export default function SFLockedIconOutlined(props) {
  return (
    <Icon
      width='14px'
      height={4}
      viewBox='0 0 14 16'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M2.8252 15.3692C1.48535 15.3692 0.774414 14.7616 0.774414 13.5615V8.32826C0.774414 7.2725 1.3304 6.68006 2.36947 6.55094V4.71285C2.36947 1.85697 4.61165 0.474609 6.99056 0.474609C9.37858 0.474609 11.6208 1.85697 11.6208 4.71285V6.55094C12.6689 6.68006 13.2158 7.2801 13.2158 8.32826V13.5615C13.2158 14.7616 12.5049 15.3692 11.165 15.3692H2.8252ZM3.81868 4.55334V6.52815H10.1807V4.55334C10.1807 2.63171 8.69499 1.62152 6.99056 1.62152C5.28613 1.62152 3.81868 2.63171 3.81868 4.55334ZM2.87077 14.2223H11.1195C11.5205 14.2223 11.7393 14.0172 11.7393 13.6451V8.24471C11.7393 7.87254 11.5205 7.67506 11.1195 7.67506H2.87077C2.47884 7.67506 2.25098 7.87254 2.25098 8.24471V13.6451C2.25098 14.0172 2.47884 14.2223 2.87077 14.2223Z' />
    </Icon>
  );
}
